import { render, staticRenderFns } from "./CongelationProduction.vue?vue&type=template&id=510120cb&"
import script from "./CongelationProduction.vue?vue&type=script&lang=js&"
export * from "./CongelationProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports